import React, { Component } from 'react'
import InlineSvg from 'svg-inline-react'
import { isEmpty } from 'lodash'

import GeoFilter from './GeoFilter'
import FirmographicFilter from './FirmographicFilter/'
import SiteVisitsFilter from './SiteVisitsFilter'
import UrlFilter from './UrlFilter'
import SalesforceFilter from './SalesforceFilter'
import TargetedAccountsFilter from './TargetedAccountsFilter'
import LeandataFilter from './LeandataFilter'
import DriftAPI from 'components/shared/DriftAPI'
import { SALES_INBOX_ID, SALES_USER_ID } from 'constants/ResourcesConstants'
import {
  geoFilter,
  firmographicFilter,
  marketTagsFilter,
  companyTagsFilter,
  siteVisitsFilter,
  urlPathFilter,
  urlHostFilter,
  urlQueryFilter,
  techTagsFilter,
  salesforceFilter,
  targetedAccountsFilter,
  headquarterStateFilter,
  headquarterCountryFilter,
  headquarterPostalCodeFilter,
  annualRevenueFilter,
  demandbaseAudienceFilter,
  demandbaseMarketingAliasFilter,
  demandbaseIndustryFilter,
  demandbaseSubIndustryFilter,
  demandbaseAnnualSalesFilter,
  demandbaseEmployeeCountFilter,
  demandbaseEmployeeRangeFilter,
  demandbaseRevenueRangeFilter,
  demandbaseHeadquarterCityFilter,
  demandbaseHeadquarterStateFilter,
  demandbaseHeadquarterCountryFilter,
  availabilityFilter,
  leandataFilter,
} from 'app/modules/rules/models'
import * as CONSTANTS from 'app/modules/rules/constants'

import './style.styl'

import GEO_ICON from '!svg-inline?removeTags=true!images/svg/geolocation.svg'
import FIRMOGRAPHICS_ICON from '!svg-inline?removeTags=true!images/svg/firmographics-small.svg'
import SITE_VISITS_ICON from '!svg-inline?removeTags=true!images/icons/window-settings.svg'
import LINK_ICON from '!svg-inline?removeTags=true!images/icons/link-icon.svg'
import SALESFORCE_ICON from '!svg-inline?removeTags=true!images/svg/salesforce-logo.svg'
import TARGETED_ACCOUNTS_ICON from '!svg-inline?removeTags=true!images/svg/rolodex.svg'
import TEAM_ICON from '!svg-inline?removeTags=true!images/svg/participant.svg'
import LEANDATA_ICON from 'images/logos/leandata.svg'

const MODELS = {
  [CONSTANTS.GEO_FILTER_TYPES.STATE]: geoFilter,
  [CONSTANTS.GEO_FILTER_TYPES.COUNTRY]: geoFilter,

  [CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS]: siteVisitsFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES]: firmographicFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MONEY_RAISED]: firmographicFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.COMPANY_CATEGORIES]: companyTagsFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MARKET_CATEGORIES]: marketTagsFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.TECH_TAGS]: techTagsFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE]: headquarterStateFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY]: headquarterCountryFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_POSTAL_CODE]: headquarterPostalCodeFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.REVENUE]: annualRevenueFilter,

  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_AUDIENCE]: demandbaseAudienceFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_MARKETING_ALIAS]: demandbaseMarketingAliasFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_INDUSTRY]: demandbaseIndustryFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_SUB_INDUSTRY]: demandbaseSubIndustryFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_COUNT]: demandbaseEmployeeCountFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_RANGE]: demandbaseEmployeeRangeFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_ANNUAL_SALES]: demandbaseAnnualSalesFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_REVENUE_RANGE]: demandbaseRevenueRangeFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_CITY]: demandbaseHeadquarterCityFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE]: demandbaseHeadquarterStateFilter,
  [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY]: demandbaseHeadquarterCountryFilter,

  [CONSTANTS.URL_FILTER_TYPES.URL_PATH]: urlPathFilter,
  [CONSTANTS.URL_FILTER_TYPES.URL_HOST]: urlHostFilter,
  [CONSTANTS.URL_FILTER_TYPES.URL_QUERY]: urlQueryFilter,

  [CONSTANTS.SALESFORCE_FILTER]: salesforceFilter,

  [CONSTANTS.TARGETED_ACCOUNTS_FILTER]: targetedAccountsFilter,

  [CONSTANTS.AVAILABILITY_FILTER]: availabilityFilter,

  [CONSTANTS.LEANDATA_FILTER]: leandataFilter,
}

const getFilterModel = type => Object.assign({}, MODELS[type])

class FilterEditor extends Component {

  openChatWidget = () => {
    const chatPayload = {}
    if (SALES_INBOX_ID && SALES_USER_ID) {
      chatPayload.inboxId = SALES_INBOX_ID
      chatPayload.sender = { id: SALES_USER_ID }
    }
    DriftAPI.showWelcomeMessage(chatPayload)
  }

  addFirmographics = () => {
    if (this.props.hasFirmographics) {
      this.addRuleFilter(CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES)
    } else {
      this.openChatWidget()
    }
  }

  addRuleFilter = (TYPE) => {
    const filterModel = getFilterModel(TYPE)
    this.props.setActiveFilter(filterModel)
  }

  addSalesforceFilter = () => {
    if (!this.props.hasSalesforceRouting) {return}

    this.addRuleFilter(CONSTANTS.SALESFORCE_FILTER)
  }

  addLeandataFilter = () => {
    if (!this.props.hasSalesforceRouting) {return}

    this.addRuleFilter(CONSTANTS.LEANDATA_FILTER)
  }

  addTargetedAccountsFilter = () => {
    if (!this.props.hasABM) {return}

    this.addRuleFilter(CONSTANTS.TARGETED_ACCOUNTS_FILTER)
  }

  renderFilterType() {
    const filters = {
      [CONSTANTS.GEO_FILTER_TYPES.STATE]: <GeoFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.GEO_FILTER_TYPES.COUNTRY]: <GeoFilter {...this.props} updateModel={this.addRuleFilter} />,

      [CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS]: <SiteVisitsFilter {...this.props} updateModel={this.addRuleFilter} />,

      [CONSTANTS.URL_FILTER_TYPES.URL_PATH]: <UrlFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.URL_FILTER_TYPES.URL_HOST]: <UrlFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.URL_FILTER_TYPES.URL_QUERY]: <UrlFilter {...this.props} updateModel={this.addRuleFilter} />,

      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MONEY_RAISED]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.COMPANY_CATEGORIES]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MARKET_CATEGORIES]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.TECH_TAGS]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_POSTAL_CODE]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.REVENUE]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,

      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_AUDIENCE]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_MARKETING_ALIAS]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_INDUSTRY]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_SUB_INDUSTRY]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_COUNT]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_RANGE]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_ANNUAL_SALES]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_REVENUE_RANGE]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_CITY]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY]: <FirmographicFilter {...this.props} updateModel={this.addRuleFilter} />,


      [CONSTANTS.SALESFORCE_FILTER]: <SalesforceFilter {...this.props} updateModel={this.addRuleFilter} />,

      [CONSTANTS.TARGETED_ACCOUNTS_FILTER]: <TargetedAccountsFilter {...this.props} updateModel={this.addRuleFilter} />,
      [CONSTANTS.LEANDATA_FILTER]: <LeandataFilter {...this.props} updateModel={this.addRuleFilter} />,
    }

    return filters[this.props.activeFilter.field]
  }

  alreadyHasFilterOf = (subType) => {
    const categoryType = CONSTANTS.CONDITION_TYPES[subType]
    const orConditions = this.props.rule.data.item.conditions[0]
    return orConditions && orConditions.find(cond => CONSTANTS.CONDITION_TYPES[cond.field] === categoryType)
  }

  renderFilterChoice() {
    const gatedFirmoClass = this.props.hasFirmographics ? '' : 'gated-filter'
    const gatedSfdcClass = this.props.hasSalesforceRouting ? '' : 'gated-filter'
    const gatedAbmClass = this.props.hasABM ? '' : 'gated-filter'
    const noConditions = isEmpty(this.props.rule.data.item.conditions[0])

    return (
      <div className="rules-chooser">
        <header>
          <h2>How do you want to route your leads?</h2>
          <p>Choose when you want this rule to run</p>
        </header>

        <div className="rules-choice-list">
          {!this.alreadyHasFilterOf(CONSTANTS.GEO_FILTER_TYPES.STATE) && (
            <div className="rules-choice-card" onClick={() => this.addRuleFilter(CONSTANTS.GEO_FILTER_TYPES.STATE)} >
              <InlineSvg src={GEO_ICON} />
              <h3>Geolocation</h3>
              <p>Match a certain region, country or state</p>
            </div>
          )}

          {!this.alreadyHasFilterOf(CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS) && (
            <div className="rules-choice-card" onClick={() => this.addRuleFilter(CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS)} >
              <InlineSvg src={SITE_VISITS_ICON} />
              <h3>Website Behavior</h3>
              <p>Match the number of times a visitor has visited your site (sessions, not page views)</p>
            </div>
          )}

          {!this.alreadyHasFilterOf(CONSTANTS.URL_FILTER_TYPES.URL_PATH) && (
            <div className="rules-choice-card" onClick={() => this.addRuleFilter(CONSTANTS.URL_FILTER_TYPES.URL_PATH)} >
              <InlineSvg src={LINK_ICON} />
              <h3>URL</h3>
              <p>Match on a number of URL parameters such as, Path, Host, Query Param and (Regex)</p>
            </div>
          )}

          <div className={`${gatedFirmoClass} rules-choice-card firmographic-choice`} onClick={this.addFirmographics}>
            <span className="upgrade-ribbon">Upgrade</span>
            <InlineSvg src={FIRMOGRAPHICS_ICON} />
            <h3>Firmographics</h3>
            <p>Match enriched data about your visitors like industry, company size, time zone etc. </p>
          </div>

          {this.props.hasSalesforceRouting && this.props.showSalesforceOption && !this.alreadyHasFilterOf(CONSTANTS.TARGETED_ACCOUNTS_FILTER) && !this.alreadyHasFilterOf(CONSTANTS.SALESFORCE_FILTER) && noConditions &&
            <div className={`${gatedSfdcClass} rules-choice-card salesforce-choice`} onClick={() => this.addSalesforceFilter()} >
              <span className="upgrade-ribbon">Upgrade</span>
              <InlineSvg src={SALESFORCE_ICON} />
              <h3>Salesforce</h3>
              <p>Add an identified contact’s Account, Contact or Lead Owner to new conversations.</p>
            </div>
          }

          {!this.alreadyHasFilterOf(CONSTANTS.SALESFORCE_FILTER) && !this.alreadyHasFilterOf(CONSTANTS.TARGETED_ACCOUNTS_FILTER) && noConditions &&
            <div className={`${gatedAbmClass} rules-choice-card targeted-accounts-choice`} onClick={() => this.props.hasABM ? this.addTargetedAccountsFilter() : location.href = '/settings/billing'} >
              <span className="upgrade-ribbon">Upgrade</span>
              <InlineSvg src={TARGETED_ACCOUNTS_ICON} />
              <h3>Targeted Accounts</h3>
              <p>Add an identified contact’s Drift account owner to new conversations.</p>
            </div>
          }

          {!this.alreadyHasFilterOf(CONSTANTS.AVAILABILITY_FILTER) && noConditions && (
            <div className="rules-choice-card" onClick={() => this.addRuleFilter(CONSTANTS.AVAILABILITY_FILTER)}>
              <InlineSvg src={TEAM_ICON} />
              <h3>Available Agents</h3>
              <p>Add an available agent from within a specified group or team.</p>
            </div>
          )}

          {this.props.hasLeandataRouting && (
            <div className="rules-choice-card" onClick={() => this.addLeandataFilter()}>
              <img src={LEANDATA_ICON} />
              <h3>LeanData</h3>
              <p>Add teammates to new conversations using LeanData lead assignment rules.</p>
            </div>
          )}
        </div>
      </div>
    )
  }

  renderChoiceOrFilter() {

    return this.props.activeFilter === 'ADD'
      ? this.renderFilterChoice()
      : this.renderFilterType()
  }

  render() {
    return (
      <div className="rules-filter-editor">
        { this.renderChoiceOrFilter() }
      </div>
    )
  }
}

export default FilterEditor



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/component.js